<template>
  <iframe
    v-if="video"
    ref="player"
    class="player"
    :src="video.url"
    frameborder="0"
    allow="microphone; camera; midi; encrypted-media; autoplay;"
    allowfullscreen
  ></iframe>
</template>

<script>
import { mapState } from 'vuex'
import Player from '@vimeo/player'
import utmParamsMixin from '@/mixins/utmParamsMixin'

export default {
  mixins: [utmParamsMixin],

  computed: {
    ...mapState('videos', ['video']),
  },

  mounted() {
    this.vimeoPlayer()
  },

  methods: {
    sendViewingData(percentage) {
      let payload = {
        video: this.video.pk,
        percentage: percentage,
      }

      let utm_params = this.getUtmParams()

      payload = { ...payload, ...utm_params }

      this.$store.dispatch('videos/sendViewingData', payload)
    },

    vimeoPlayer() {
      const player = new Player(this.$refs.player)
      player.getDuration().then(duration => {
        const points = this.video.video_points
        const interval = 100 / points
        const cuepoints = Array.from(
          { length: points - 1 },
          (_, i) => interval + i * interval
        )

        cuepoints.forEach(cue =>
          player.addCuePoint((duration * cue) / 100, cue)
        )

        player.on('cuepoint', cp => this.sendViewingData(cp.data))

        player.on('ended', () => this.sendViewingData(100))
      })
    },
  },
}
</script>
